"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, { UiFormAnnotations, UiFormController } from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import i18n from "@/lang";
export class BindVdInfoForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.exchange_number = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("bindvd.please_enter_the_cdkey"),
    trigger: "blur"
  }])
], BindVdInfoForm.prototype, "exchange_number", 2);
let BindVd = class extends Vue {
  constructor() {
    super(...arguments);
    this.accessMode = "";
    this.dialogLoading = false;
    this.dialog = new UiDialogController();
    this.controller = new BindVdInfoForm();
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        const response = yield API.post(`api://base.auth/api/v7/vdcard/exchange`, {
          exchange_number: this.controller.exchange_number
        });
        this.$message.success(this.$t("bindvd.binding_success"));
      } catch (error) {
        console.log("error", error);
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.close();
      }
    });
  }
  open() {
    this.controller = new BindVdInfoForm();
    this.dialog.visible = true;
  }
  close() {
    this.dialog.visible = false;
    this.$emit("refresh");
  }
  closeDepartmentDialog() {
    this.controller.exchange_number = "";
    this.dialog.visible = false;
  }
};
BindVd = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog
    }
  })
], BindVd);
export {
  BindVd as default
};
